// @ngInject
function BrandsApiService(ResourcesService) {

    var endpoint = 'brands';

    return {
        getBrands: ResourcesService.apiFactory.get(endpoint),
        getBrand: ResourcesService.apiFactory.get(endpoint),
        createBrand: createBrand,
        updateBrand: updateBrand,
        getTenantConfig: ResourcesService.apiFactory.get(endpoint + '/tenantconfig'),
        getMainGroups: ResourcesService.apiFactory.get(endpoint + '/maingroups'),
        getCompanies: ResourcesService.apiFactory.get(endpoint + '/companies'),
        getBrandCategories: ResourcesService.apiFactory.get(endpoint + '/brandcategories'),
        getSalesChannels: ResourcesService.apiFactory.get(endpoint + '/saleschannels'),
        getVariantGroups: ResourcesService.apiFactory.get(endpoint + '/variantgroups'),
        getBarcodeTypes: ResourcesService.apiFactory.get(endpoint + '/barcodetypes'),
        createItemGroups: createItemGroups
    };

    function createBrand(brand, mainGroups, addedCompanies, removedCompanies) {

        var args = {
            brand: brand,
            mainGroups: mainGroups,
            addedCompanies: addedCompanies,
            removedCompanies: removedCompanies
        };

        return ResourcesService.apiFactory.create(endpoint,'Brand')(args);

    }

    function updateBrand(brand, mainGroups, addedCompanies, removedCompanies) {

        var args = {
            brand: brand,
            mainGroups: mainGroups,
            addedCompanies: addedCompanies,
            removedCompanies: removedCompanies
        };

        return ResourcesService.apiFactory.update(endpoint,'Brand')(args);
    }

    function createItemGroups(mainGroups, brands) {

        var args = {
            mainGroups: mainGroups,
            brands: brands
        };

        return ResourcesService.apiFactory.update(endpoint + '/createitemgroups','MainGroup')(args);
    }

}


angular.module('brands.api', [])
  .factory('BrandsApiService', BrandsApiService);
